import { LIMIT_FILE_SIZE } from 'constants/index';
import { showToastError } from 'utils';

const getExtension = (filename) => {
  const parts = filename.split('.');
  return parts[parts.length - 1];
};

export const isImage = (filename) => {
  const ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case 'jpg':
    case 'jpeg':
    case 'png':
      return true;

    default:
      return false;
  }
};

export const isVideo = (filename) => {
  const ext = getExtension(filename);
  switch (ext.toLowerCase()) {
    case 'mp4':
    case 'webm':
    case 'mov':
    case 'm4v':
    case 'mkv':
    case 'avi':
    case 'wmv':
    case 'flv':
      return true;

    default:
      return false;
  }
};

const formatUploadImages = (
  file,
  options = {
    limitValue: 0,
    fileSize: LIMIT_FILE_SIZE.LARGE,
  },
) => {
  let fileList;

  if (options.limitValue > 0) {
    fileList = Object.values(file).slice(0, options.limitValue);
  } else {
    fileList = Object.values(file);
  }

  const maxFileSize = options.fileSizeFormat || options.fileSize || LIMIT_FILE_SIZE.LARGE;

  const newFileList = fileList.map((item) => {
    if (!isImage(item.name)) {
      showToastError('Ảnh định dạng JPG, JPEG, PNG');
      return null;
    }

    if (item.size > maxFileSize) {
      showToastError(`Dung lượng ảnh không quá ${maxFileSize / (1024 * 1024)}MB`);
      return null;
    }

    return ({
      file: item,
      blob: URL.createObjectURL(item),
    });
  });

  return newFileList.filter((item) => item !== null);
};

export const splitUploadMediaFiles = (
  file,
  options = {
    limitValue: 0,
    fileSize: LIMIT_FILE_SIZE.LARGE,
    videoFileSize: LIMIT_FILE_SIZE.BIG,
  },
) => {
  let fileList;

  if (options.limitValue > 0) {
    fileList = Object.values(file).slice(0, options.limitValue);
  } else {
    fileList = Object.values(file);
  }

  const maxImageSize = options.fileSize || LIMIT_FILE_SIZE.LARGE;
  const maxVideoSize = options.videoFileSize || LIMIT_FILE_SIZE.BIG;
  const images = [];
  const videos = [];

  fileList.forEach((item) => {
    if (isImage(item.name)) {
      if (item.size > maxImageSize) {
        showToastError(`Dung lượng ảnh không quá ${maxImageSize / (1024 * 1024)}MB`);
        return;
      }

      images.push({
        file: item,
        blob: URL.createObjectURL(item),
      });
      return;
    }

    if (isVideo(item.name)) {
      if (item.size > maxVideoSize) {
        showToastError(`Dung lượng video không quá ${maxVideoSize / (1024 * 1024)}MB`);
        return;
      }

      videos.push({
        file: item,
        blob: URL.createObjectURL(item),
      });
      return;
    }

    showToastError('Chỉ hỗ trợ ảnh JPG, JPEG, PNG hoặc video MP4, WEBM, MOV, M4V, MKV, AVI');
  });

  return { images, videos };
};

export const normalizeUploadedMediaUrls = (payload) => {
  if (!payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (typeof payload === 'string') {
    return [payload];
  }

  if (payload.url) {
    return [payload.url];
  }

  if (payload.image) {
    return [payload.image];
  }

  return [payload];
};

export default formatUploadImages;
